<template>
  <div class="paperFile">
    <!-- 论文-->
    <div class="flex_left">
      <div class="kontribuo">
        <div class="qikan_instar">
          <img v-if="jous_list.coverImg" :src="$global.imgUrl + jous_list.coverImg" />
          <div class="journal">
            <h3>
              {{ jous_list.name }}
            </h3>
            <p style="margin-top: 10px">
              主管单位: <span>{{ jous_list.responsibleDept }}</span>
            </p>
            <p>
              主办单位:
              <span>{{ jous_list.organizer }}</span>
            </p>
            <p>
              出版单位: <span>{{ jous_list.publishCompany }}</span>
            </p>

            <p>
              CN：<span>{{ jous_list.cn }}</span>
            </p>
            <p>
              ISSN: <span>{{ jous_list.issn }}</span>
            </p>
            <p>
              出版周期: <span>{{ jous_list.publishPeriod }}</span>
            </p>

            <p v-if="coreName != '' || listGve != ''">
              收录数据库:
              <span>
                <span style="color: #2150cb">{{ coreName }}</span>
                {{ listGve }}</span
              >
            </p>
          </div>
        </div>
        <div :class="list_top ? 'introduction chaochu' : 'introduction '">
          简介：<span v-html="jous_list.periodicalIntro"></span>
          <div class="zhankai" v-if="list_top" @click="qunall">
            展开全部
            <img src="@/assets/image/arrow_down.png" style="width: 12px; height: 8px" />
          </div>
          <div class="zhankai" v-if="!list_top" @click="qunsq">
            收起<img src="@/assets/image/folder.png" style="width: 12px; height: 8px" />
          </div>
        </div>
      </div>
      <div class="right_kotribuo">
        <div class="livests">
          <!-- <div class="contribute" @click="zaixian(),linkHref('touGao')">
            <img src="@/assets/image/zaixiantougao.png" />
            <h3>在线投稿</h3>
          </div> -->
          <div class="Qrcodse">
            <div id="qrCode" ref="qrCodeDiv"></div>
            <p>扫描二维码</p>
          </div>
          <Button type="primary" @click="livest()">投稿须知</Button>
          <Button type="primary" @click="ziazai()">论文模版</Button>
          <Button type="primary" @click="solicit()">征稿启示</Button>
          <!-- <Button type="primary" @click="soclves(),linkHref('jinDu')">进度查询</Button> -->
          <div class="contribute" style="margin-top: 20px; display: none">
            <img style="width: 100px; height: 100px" src="@/assets/image/qrcode.png" />
            <p>期刊公众号</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 栏目设置 -->
    <div v-if="columnSti.length != 0">
      <div class="column_list">
        <img src="@/assets/image/channel_setting.png" />
        <h3>栏目设置</h3>
      </div>
      <div
        class="gitcommits"
        v-if="listaf"
        v-for="(item, index) in columnSti"
        :key="index"
      >
        <div class="conlumn_center daijq">
          <h3>{{ item.name }}</h3>
          <p v-if="item.estimatedReleaseTime">
            （预计发表时间{{ item.estimatedReleaseTime }}）
          </p>
        </div>
        <div :class="item.gitehave ? 'dingwei chaochus' : 'dingwei'">
          {{ item.description }}
          <!-- v-if="item.description.length >= 160" -->
          <div class="livestsg" v-if="item.description.length >= 160">
            <div>
              <div class="listtop" v-if="item.gitehave" @click="zhankais(index)">
                展开全部
                <img
                  src="@/assets/image/arrow_down.png"
                  style="width: 12px; height: 8px"
                />
              </div>
              <div class="listtop" v-if="!item.gitehave" @click="shouqi(index)">
                收起
                <img src="@/assets/image/folder.png" style="width: 12px; height: 8px" />
              </div>
            </div>
          </div>
          <!-- <div v-else class="livestsg"></div> -->
        </div>
      </div>
      <!-- <div class="conlumn_center">
        <div class="conlum_name" v-for="(item, index) in columnSti" :key="index">
          <h3>
            {{ item.name
            }}<span v-if="item.estimatedReleaseTime"
              >（ 预计发表时间 {{ item.estimatedReleaseTime }}）</span
            >
          </h3>
          <p>
            {{ item.description }}
          </p>
        </div>
      </div> -->
    </div>
    <Modal
      v-model="git_live"
      width="870px"
      class-name="vertical-center-modal"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div style="min-height: 580px; padding: 10px 20px 20px 20px" class="git_have">
        <h3
          style="
            color: #2150cb;
            font-family: PingFang SC;
            font-weight: bold;
            color: #2150cb;
            font-size: 18px;
          "
        >
          投稿须知
        </h3>
        <div
          style="border: 1px solid #e5e5e5"
          class="livest"
          v-html="jous_list.authorsNotice"
        ></div>
        <!-- <Button @click="cancel">关闭</Button> -->
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal
      v-model="git_solicit"
      width="870px"
      class-name="vertical-center-modal"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div style="min-height: 580px; padding: 10px 20px 20px 20px" class="git_have">
        <h3
          style="
            color: #2150cb;
            font-family: PingFang SC;
            font-weight: bold;
            color: #2150cb;
            font-size: 18px;
          "
        >
          约稿函
        </h3>
        <div
          style="border: 1px solid #e5e5e5"
          class="livest"
          v-html="jous_list.periodicalRevelation"
        ></div>
        <!-- <Button @click="cancel">关闭</Button> -->
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal
      v-model="gitHave"
      width="700px"
      class-name="vertical-center-modal"
      :mask-closable="false"
      :closable="false"
      @on-cancel="cancel"
    >
      <div style="min-height: 100px" class="git_have">
        <div class="livest">
          <p style="text-align: center; margin-top: 40px">
            《{{ jous_list.name }}期刊》尚未开通中文知识网融合出版服务平台.
          </p>
          <p style="text-align: center">
            如果您是作者想给本刊投稿或查询进度，请与编辑部直接联系！
          </p>
        </div>

        <Button @click="cancel">关闭</Button>
      </div>

      <div slot="footer"></div>
    </Modal>
    <Modal
      v-model="gitlist"
      width="400px"
      class-name="vertical-center-modal"
      :mask-closable="false"
      :closable="false"
      @on-cancel="cancive"
    >
      <p style="text-align: center; padding: 40px 0px">
        您的账号暂无认证，请认证后再投稿!
      </p>

      <div style="padding-bottom: 50px">
        <Button style="margin-left: 33%" @click="cancive">关闭</Button>
        <Button type="primary" style="margin-left: 3%" @click="liveGive">验证</Button>
      </div>
    </Modal>

    <modalfiles v-if="listGive" :listGive="listGive" @getlist="getlist"></modalfiles>
  </div>
</template>
<script>
var vm;
import modalfiles from "../../components/Modal_fiels";
import QRCode from "qrcodejs2";
export default {
  name: "paperFile",
  props: ["userBehaviorData"],
  data() {
    return {
      columnSti: [],
      titles:
        "简介栏目说明，栏目说明栏目说明栏目说明栏目说明，栏目说明栏目说明栏目说明栏目说明栏目说明栏目说明栏目说明，栏目，说明栏目说明栏目说明栏目说明栏目说明栏目说明栏目说明。简介栏目说。栏目说明栏目rwerwqerwqrwerwqre说明栏目说明栏目说明，栏目说明栏目说明栏目说明栏目说明栏目说明栏目说明栏fafasdfas目说明栏目说明栏目说明栏目说明栏目栏目说明栏栏目说明栏目",
      // 159
      jous_list: [],
      coverImg: "",
      git_live: false,
      git_solicit: false,
      list_top: true,
      gitHave: false,
      list_Data: [],
      coreName: "",
      listGve: [],
      gitlist: false,
      listGive: false,
      gitehave: true,
      tosring: -1,
      listaf: false,
    };
  },
  components: {
    modalfiles: modalfiles,
  },
  computed: {
    status() {
      //  计算属性
      return this.$store.state.eventStatus; //  Vuex 中定义的属性
    },
  },
  watch: {
    status() {
      var linkName = this.$store.state.linkName;
      var linkType = this.$store.state.linkType;
      if (linkName == "touGao") {
        this.zaixian();
        if (linkType) {
          setTimeout(() => {
            this.$store.state.linkType = false;
            location.reload();
          }, 500);
        }
      } else if (linkName == "jinDu") {
        this.soclves();
        if (linkType) {
          setTimeout(() => {
            this.$store.state.linkType = false;
            location.reload();
          }, 500);
        }
      }
    },
  },
  created() {
    vm = this;
  },
  mounted() {
    vm.columnSetup();
    vm.jourShow();
    vm.deataKive();
    this.$nextTick(function () {
      this.bindQRCode();
    });
  },
  methods: {
    // 用户点击行为统计
    statisticUserBehavior(btnName) {
      this.userBehaviorData.clickName = btnName;
      vm.$apis.manage.userBehaviorStatistics(this.userBehaviorData);
    },
    //生成二维码
    bindQRCode() {
      var urlList = window.location.href;
      console.log(urlList, 111);
      /*
      http://192.168.1.161:8081/?editId=1446352177927950336&perId=1297783010043576320
      下方链接地址多路由/Bulletin，导致二维码扫不出结果，手动过滤路由
      http://192.168.1.161:8081/Bulletin?editId=1446352177927950336&perId=1297783010043576320
      */
      urlList = location.origin + "/" + location.search;
      new QRCode(this.$refs.qrCodeDiv, {
        text: urlList,
        width: 70,
        height: 70,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },
    //跳转存值
    linkHref(name) {
      if (name) this.$store.state.linkName = name;
    },
    cancive() {
      this.gitlist = false;
    },
    liveGive() {
      this.gitlist = false;
      this.$router.push({
        path: "/cardHolder",
        query: {
          perName: 4,
          editId: this.$store.state.cbianId,
          perId: this.$store.state.qikanId,
        },
      });
    },
    cancel() {
      vm.git_live = false;
      vm.git_solicit = false;
      this.gitHave = false;
    },
    deataKive() {
      //登录之后如果userid有就传，登录之前就没有1440845449643823104
      var token = this.$store.state.token;
      if (token) {
        var data = {
          editId: this.$store.state.cbianId,
          perId: this.$store.state.qikanId,
          userId: this.$store.state.userId,
          username: this.$store.state.userName,
        };
      } else {
        var data = {
          editId: this.$store.state.cbianId,
          perId: this.$store.state.qikanId,
        };
      }
      vm.$apis.manage.detailsLive(data).then((res) => {
        vm.list_Data = res.data;
      });
    },
    getlist(names) {
      this.listGive = names;
    },
    zaixian() {
      var urlList = "";
      if (
        location.host.indexOf("cbtest.") != -1 ||
        location.host.indexOf("127.") != -1 ||
        location.host.indexOf("localhost") != -1
      ) {
        urlList = "https://dev.cnknowledge.com/newtsgweb/?token="; //
      } else if (location.host.indexOf("yucard") != -1) {
        urlList = "https://yutsg.cnknowledge.com/newtsgweb?token="; //
      } else {
        urlList = "https://publish.cnknowledge.com/newtsgweb?token="; //
      }
      // var urlList =
      //   location.host.indexOf("cbtest.") != -1 || location.host.indexOf(":80") != -1
      //     ? "http://dev.cnknowledge.com/newtsgweb/?token="
      //     : "http://publish.cnknowledge.com/newtsgweb?token=";
      var token = window.sessionStorage.getItem("token");
      var perName = this.jous_list.name;
      this.$apis.manage
        .getPerEditCardConfig({ perId: this.$route.query.perId })
        .then((res) => {
          if(res.periodicalEditCardConfig.submitType == 2){
          if (res.periodicalEditCardConfig.submitUrl) {
              var mywin = window.open(
                res.periodicalEditCardConfig.submitUrl +
                  `/?token=${token}&editId=${this.$store.state.cbianId}&prid=${this.$store.state.qikanId}#/manage/author?perName=${perName}`
              );
              mywin.location.reload(true);
            }
          } else {
            if (token) {
              vm.$apis.manage.getUserInfo().then((res) => {
                var list_name;
                // var list_name = res.content.detail.userInfo.nickname
                //   ? res.content.detail.userInfo.nickname
                //   : res.content.detail.userInfo.realname
                //   ? res.content.detail.userInfo.realname
                //   : res.content.detail.userInfo.mobile;
                if (res.content.detail.userInfo) {
                  if (res.content.detail.userInfo.nickname) {
                    list_name = res.content.detail.userInfo.nickname;
                  } else if (res.content.detail.userInfo.realname) {
                    list_name = res.content.detail.userInfo.realname;
                  } else if (res.content.detail.userInfo.mobile) {
                    list_name = res.content.detail.userInfo.mobile;
                  }
                } else {
                  this.$Message.destroy();
                  setTimeout(function () {
                    vm.$Message.error("请完善您的个人信息");
                  }, 500);
                  vm.listGive = true;
                  return;
                }
                if (list_name) {
                  // if (!res.content.detail.userInfo.idCard) {
                  //   this.gitlist = true;
                  //   return;
                  // }
                  if (this.jous_list.contribute == 0) {
                    this.gitHave = true;
                  } else {
                    this.gitHave = false;
                    // console.log(vm.list_Data);
                    // return;
                    // if (vm.list_Data.editType == 1) {
                    //   var mywin = window.open(
                    //     `${urlList}&prid=${
                    //       this.$store.state.qikanId
                    //     }#/manage/notice?perName=${perName}&name=${
                    //       vm.list_Data.name
                    //     }&preliminaryId=${vm.list_Data.preliminaryId}&userId=${
                    //       vm.list_Data.userId
                    //     }&solicitName=${""}`
                    //   );
                    // } else if (vm.list_Data.editType == 2) {
                    //   var mywin = window.open(
                    //     `${urlList}&prid=${this.$store.state.qikanId}#/manage/notice?perName=${perName}&name=${vm.list_Data.dockingEditName}&solicitName=${vm.list_Data.name}&userId=${vm.list_Data.dockingEditId}&preliminaryId=${vm.list_Data.preliminaryId}&solicitId=${vm.list_Data.userId}`
                    //   );
                    // }
                    if (vm.list_Data.editType == 1) {
                      var mywin = window.open(
                        `${urlList}&editId=${this.$store.state.cbianId}&prid=${this.$store.state.qikanId}#/manage/author?perName=${perName}`
                      );
                    } else if (vm.list_Data.editType == 2) {
                      var mywin = window.open(
                        `${urlList}&prid=${this.$store.state.qikanId}#/manage/author?perName=${perName}&name=${vm.list_Data.dockingEditName}&solicitName=${vm.list_Data.name}&userId=${vm.list_Data.dockingEditId}&preliminaryId=${vm.list_Data.preliminaryId}&solicitId=${vm.list_Data.userId}`
                      );
                    }
                    mywin.location.reload(true);
                  }
                } else {
                  this.$Message.destroy();
                  setTimeout(function () {
                    vm.$Message.error("请完善您的个人信息");
                  }, 500);
                }
              });
            } else {
              this.$root.Bus.$emit("analy", true);
              this.$Message.destroy();
              setTimeout(function () {
                // vm.$Message.error("请登录您的用户");
              }, 500);
            }
          }
        });

      // http://dev.cnknowledge.com/newtsgweb/?token=undefined&prid=1297783010043576320#/manage/author
    },

    soclves() {
      // var token = this.$store.state.token || window.sessionStorage.getItem("token", token);
      // if (token) {
      //   if (this.jous_list.contribute == 1) {
      //     vm.$router.push({
      //       path: "/cardHolder",
      //       query: {
      //         perName: 3,
      //         editId: this.$store.state.cbianId,
      //         perId: this.$store.state.qikanId,
      //       },
      //     });
      //   } else {
      //     this.gitHave = true;
      //   }
      // } else {
      //   this.$root.Bus.$emit("analy", true);
      //   vm.$Message.error("请登录您的用户");
      // }
      var token = window.sessionStorage.getItem("token", token);
      var urlList = "";
      if (token) {
        vm.$apis.manage.getUserInfo().then((res) => {
          if (res.resultCode == 200) {
            if (
              location.host.indexOf("cbtest.") != -1 ||
              location.host.indexOf("127.") != -1 ||
              location.host.indexOf("localhost") != -1
            ) {
              urlList = "https://dev.cnknowledge.com/newtsgweb/?token="; //
            } else if (location.host.indexOf("yucard") != -1) {
              urlList = "https://yutsg.cnknowledge.com/newtsgweb?token="; //
            } else {
              urlList = "https://publish.cnknowledge.com/newtsgweb?token="; //
            }
            var mywin = window.open(
              `${urlList}&editId=${this.$store.state.cbianId}&prid=${this.$store.state.qikanId}#/manage/mySubmission`
            );
            mywin.location.reload(true);
          }
        });
      } else {
        this.$root.Bus.$emit("analy", true);
        // vm.$Message.error("请登录您的用户");
      }
    },
    ziazai() {
      this.statisticUserBehavior("论文模板");
      this.$apis.manage.thesisTemple({ perId: this.$store.state.qikanId }).then((res) => {
        window.open(this.$global.imgUrl + res.content.thesisTemplet);
      });
    },
    //栏目设置
    columnSetup() {
      var data = {
        periodicalId: this.$store.state.qikanId,
        flag: 0,
      };
      vm.$apis.manage.columnSetup(data).then((res) => {
        vm.columnSti = res.content.columnList;
        vm.columnSti.map((item) => {
          item.gitehave = true;
        });
        this.listaf = true;
      });
    },
    zhankais(index) {
      this.listaf = false;
      vm.columnSti[index].gitehave = false;
      this.listaf = true;
    },
    shouqi(index) {
      vm.columnSetup();
      vm.columnSti[index].gitehave = true;
    },
    qunall() {
      vm.list_top = false;
    },
    qunsq() {
      vm.list_top = true;
    },
    //期刊展示
    jourShow() {
      var data = {
        perId: this.$store.state.qikanId,
      };
      vm.$apis.manage.jourShow(data).then((res) => {
        vm.jous_list = res.content.vo;
        vm.coverImg = res.content.vo.coverImg;
        var listGit = [];
        var listweb = res.content.vo.list;
        listweb.map((item) => {
          listGit.push(item.name);
        });
        this.listGve = listGit.toString().replace(/,/g, " ");

        window.sessionStorage.setItem("julistName", vm.jous_list.name);
        vm.coreName = vm.jous_list.coreName.replace(/,/, "   ");
        vm.jous_list.publishPeriod = vm.jous_list.publishPeriod
          ? vm.$global.publishPeriod(vm.jous_list.publishPeriod)
          : "";
      });
    },
    livest() {
      vm.git_live = true;
      this.statisticUserBehavior("投稿须知");
    },
    solicit() {
      vm.git_solicit = true;
      this.statisticUserBehavior("征稿启事");
    },
  },
};
</script>
<style scoped="scoped" lang="scss">
/deep/.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
/deep/.ivu-modal-footer {
  display: none;
}
.livest {
  padding: 25px 35px;
  line-height: 30px;
  max-height: 480px;
  min-height: 420px;
  overflow-y: scroll;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.git_have h3 {
  text-align: center;
  // line-height: 50px;
  margin-bottom: 20px;
}
.git_have button {
  margin: 10px auto;
  display: block;
}

.paperFile {
  width: 100%;
  background: #ffffff;
  padding: 40px;
  margin-bottom: 20px;
}
.flex_left {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
.kontribuo {
  width: 80%;
  padding-right: 40px;
  border-right: 1px solid #cccccc;
}
.qikan_instar img {
  width: 220px;
  height: 270px;
  display: block;
  float: left;
  padding-right: 40px;
  padding-bottom: 30px;
}

.introduction {
  width: 100%;
  padding: 10px 15px;
  margin-top: 20px;
  // height: 142px;
  background: #f3f8fd;
  display: -webkit-box;
  font-size: 14px !important;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  position: relative;
  line-height: 30px;
  padding-bottom: 30px;
}
.introduction span /deep/span {
  font-size: 14px !important;
}
.zhankai {
  width: 100%;
  position: absolute;
  height: 30px;
  right: 0px;
  bottom: 0px;
  cursor: pointer;
  background: #f3f8fd;
  padding: 3px 5px;
  text-align: right;
  line-height: 21px;
}
.chaochu {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.journal h3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.journal h3 span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  margin-left: 15px;
}
.contribute {
  cursor: pointer;
}
.contribute img {
  width: 80px;
  height: 80px;
  display: block;
  margin: 0px auto;
}
.contribute h3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2150cb;
  line-height: 30px;
  text-align: center;
}
.contribute p {
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
}
.journal p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
}
.right_kotribuo {
  width: 10%;

  position: relative;
  margin-right: 50px;
}
.livests {
  position: absolute;
  right: 0px;
  bottom: 0px;
  top: 20px;
}
.right_kotribuo Button {
  width: 100px;
  height: 32px;
  background: #2150cb;
  display: block;
  margin: 25px auto;
  border-radius: 6px;
}
.column_list {
  margin-top: 40px;
  margin-bottom: 30px;
}
.column_list img {
  width: 30px;
  height: 30px;
  display: block;
  float: left;
}
.column_list h3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
  text-indent: 0.5em;
}
.conlumn_center {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.conlum_name {
  width: 550px;
  padding: 22px;
  margin-top: 15px;
  background: #f3f8fd;
}
.conlum_name h3 {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.conlum_name h3 span {
  color: #07309a;
}
.conlum_name p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 7px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.livest::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.livest::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  background: #5d89fa;
  border-radius: 4px;
}
.livest::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  background: #e5e5e5;
  border-radius: 4px;
}
.gitcommits {
  margin-top: 20px;
  margin-bottom: 25px;
}
.daijq h3 {
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  font-size: 16px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.daijq p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #2150cb;
  line-height: 30px;
}
.dingwei {
  position: relative;
  padding-top: 10px;
  padding-bottom: 30px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
}
.livestsg {
  width: 100%;
  height: 30px;
  position: absolute;
  left: 0px;
  bottom: 0px;
  background: #ffffff;
  line-height: 24px;
}
.listtop {
  float: right;
  cursor: pointer;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #4074f7;
  opacity: 0.72;
}
.chaochus {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.Qrcodse {
  text-align: center;
}
.Qrcodse p {
  color: #2150cb;
}
#qrCode {
  width: 70px;
  height: 70px;
  margin: 10px auto;
}
</style>
